<template>
  <div>
    <div class="flex justify-between items-center my-8">
      <div>
        <h2 class="text-2xl font-semibold">Order Management</h2>
      </div>
      <div class="flex">
        <base-button outline type="primary" class="flex px-3 py-1 mx-1">
          <download-excel
            class="mr-1 flex"
            default-value=""
            :fetch="fetchSelected"
            :fields="json_fields"
            worksheet="My Worksheet"
            name="Order_Details.xls"
          >
            <feather-icon icon="UploadIcon" class="mr-2 cust-HW"></feather-icon
            >Export Selected
          </download-excel>
        </base-button>
        <base-button outline type="primary" class="flex px-3 py-1 mx-1">
          <download-excel
            class="mr-1 flex"
            default-value=""
            :fetch="fetchData"
            :fields="json_fields"
            worksheet="My Worksheet"
            name="Order_Details.xls"
          >
            <feather-icon icon="UploadIcon" class="mr-2 cust-HW"></feather-icon
            >Export All
          </download-excel>
        </base-button>
      </div>
    </div>
    <b-input-group class="mt-8">
      <b-form-input
        class="border-none shadow-lg"
        type="text"
        min="0.00"
        v-model="search"
        @input="loadData"
        placeholder="Enter Search...."
      ></b-form-input>

      <b-input-group-append>
        <b-button
          variant="white"
          class="flex items-center shadow-lg"
          aria-label="search"
        >
          <feather-icon
            class="cursor-pointer mr-2"
            icon="SearchIcon"
            svgClasses="w-4 h-4"
          ></feather-icon>
        </b-button>
      </b-input-group-append>
    </b-input-group>
    <div class="flex justify-between items-center">
      <div class="flex gap-4 py-3">
        <div>
          <div>
            <label for="">Start Date</label>
          </div>
          <input
            id="custdatepicker"
            class="custdatepicker"
            v-model="startDate"
            type="date"
            placeholder="Pick a day"
          />
        </div>
        <div>
          <div>
            <label for="">End Date</label>
          </div>
          <input
            id="custdatepicker"
            class="custdatepicker"
            v-model="endDate"
            type="date"
            placeholder="Pick a day"
          />
        </div>
      </div>
      <div class="flex">
        <base-button
          outline
          type="primary"
          class="flex px-3 py-1 mx-1"
          @click="filterDate"
        >
          Filter
        </base-button>
        <base-button
          outline
          type="primary"
          class="flex px-3 py-1 mx-1"
          @click="clearFilter"
        >
          Clear All
        </base-button>
      </div>

      <!-- <div class="pt-12">
        
        </div> -->
    </div>
    <el-table
      border
      :data="this.productOrder.result"
      class="table-responsive table-flush mt-6"
      header-row-class-name="thead-light table-th-color"
      @selection-change="selectedRow"
    >
      <el-table-column type="selection" width="50px"> </el-table-column>
      <el-table-column
        prop="invoiceId"
        label="Invoice Id"
        min-width="120px"
        v-slot="{ row }"
      >
        {{ row.invoiceId }}
      </el-table-column>
      <el-table-column
        prop="brandName"
        label="Brand Name"
        min-width="120px"
        v-slot="{ row }"
      >
        {{ row.brandDetails.name }}
      </el-table-column>
      <el-table-column
        prop="prodName"
        label="Product Name"
        min-width="120px"
        v-slot="{ row }"
      >
        {{ row.productDetails.name.slice(0, 50) }}...
      </el-table-column>

      <el-table-column
        prop="Name"
        label="Full Name"
        min-width="120px"
        v-slot="{ row }"
      >
        {{ row.deliveryDetails.fullName }}
      </el-table-column>
      <el-table-column
        label="Email"
        min-width="150px"
        prop="Email"
        v-slot="{ row }"
      >
        {{ row.deliveryDetails.email }}
      </el-table-column>
      <el-table-column
        label="Mobile"
        min-width="150px"
        prop="mobile"
        v-slot="{ row }"
      >
        {{ row.deliveryDetails.phoneNumber }}
      </el-table-column>
      <el-table-column
        prop="address"
        min-width="150px"
        label="Address"
        v-slot="{ row }"
      >
        {{ row.deliveryDetails.address.slice(0, 50) }}...
      </el-table-column>
      <!--  <el-table-column
        prop="landmark"
        min-width="50px"
        label="Landmark"
        v-slot="{ row }"
      >
        {{ row.deliveryDetailsArray.landMark }}
      </el-table-column> -->
      <el-table-column
        prop="towncity"
        min-width="150px"
        label="Town/City"
        v-slot="{ row }"
      >
        {{ row.deliveryDetails.townCity }}
      </el-table-column>
      <el-table-column
        prop="pincode"
        label="PinCode"
        min-width="150px"
        v-slot="{ row }"
      >
        {{ row.deliveryDetails.pinCode }}
      </el-table-column>
      <el-table-column
        prop="State"
        label="State"
        min-width="150px"
        v-slot="{ row }"
      >
        {{ row.deliveryDetails.state }}
      </el-table-column>
      <el-table-column
        prop="Date"
        label="Date"
        min-width="150px"
        v-slot="{ row }"
      >
        {{
          new Date(row.createdAt).toLocaleDateString(undefined, {
            year: "numeric",
            month: "long",
            day: "numeric",
          })
        }}
      </el-table-column>
      <el-table-column
        prop="Payment Status"
        label="Payment Status"
        min-width="150px"
        v-slot="{ row }"
      >
        {{ row.paymentStatus }}
      </el-table-column>

      <!-- <el-table-column prop="actions" label="Actions" min-width="40px">
        <template slot-scope="">
          <div class="flex gap-1 items-center">
            <feather-icon
              icon="EditIcon"
              svgClasses="w-4 h-4"
              class="cursor-pointer"
            />
            <feather-icon
              icon="TrashIcon"
              svgClasses="w-4 h-4"
              class="cursor-pointer"
            />
          </div>
        </template>
      </el-table-column> -->
    </el-table>
    <b-card-footer class="py-4 d-flex justify-content-end">
      <base-pagination
        v-model="currentPage"
        @change="handlePageChange"
        :per-page="perPage"
        :total="total_row"
      ></base-pagination>
    </b-card-footer>
  </div>
</template>
<script>
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
} from "element-ui";
import { mapState } from "vuex";
export default {
  name: "light-table",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
  },
  data() {
    return {
      tableData: [],
      currentPage: 1,
      total_row: 1,
      perPage: 10,
      multipleSelection: [],
      search: "",
      startDate: "",
      endDate: "",
      selectedData: [],
    };
  },
  watch: {
    // async currentPage() {
    //   await this.getAll();
    // },
    // search: {
    //   handler: _.debounce(async function (val) {
    //     this.loadData();
    //     // this.currentPage = 1;
    //   }, 500),
    // },
  },
  methods: {
    selectedRow(val) {
      this.selectedData = val;
    },
    async fetchSelected() {
      if (this.selectedData.length === 0) {
        return this.$swal({
          title: "No Selection!",
          html: `<p class="text-center">Please select rows to be exported!</p>`,
          icon: "warning",
          showCancelButton: false,
          confirmButtonColor: "#830c81",
        });
      }
      let loader = this.$loading();
      try {
        loader.close();
        this.$swal({
          html: `<p class="text-center">Data has been successfully exported!</p>`,
          icon: "success",
          showCancelButton: false,
          confirmButtonColor: "#830c81",
        });
        return this.selectedData;
      } catch (error) {
        loader.close();
      }
    },
    async fetchData() {
      let payload = {
        limit: this.total_row,
      };

      if (this.search !== "")
        Object.assign(payload, { search: this.search.trim() });

      let loader = this.$loading();
      try {
        let data = await this.$store.dispatch("affiliate/getOrder", payload);
        // console.log(data, "///");
        if (data.code == 200) {
          loader.close();
          this.$swal({
            html: `<p class="text-center">Data has been successfully exported!</p>`,
            icon: "success",
            showCancelButton: false,
            confirmButtonColor: "#830c81",
          });
          return data.data.result;
        }
        loader.close();
      } catch (error) {
        loader.close();
      }
    },

    async handlePageChange(value) {
      this.currentPage = value;
      try {
        this.loadData();
      } catch (error) {}
    },
    async loadData() {
      let payload = {
        search: this.search.trim(),
        limit: 10,
        offset: (this.currentPage - 1) * 10,
        startDate: this.startDate,
        endDate: this.endDate,
      };
      try {
        let data = await this.$store.dispatch("affiliate/getOrder", payload);
        this.total_row = this.productOrder.totalCount;
      } catch (error) {
        console.log(error);
      }
    },
    async filterDate() {
      try {
        this.loadData();
      } catch (error) {}
    },
    async clearFilter() {
      try {
        this.startDate = "";
        this.endDate = "";
        this.search = "";
        this.loadData();
      } catch (error) {}
    },
  },
  computed: {
    ...mapState("affiliate", {
      productOrder: "productOrder",
    }),
    json_fields() {
      return {
        Invoice_Id: "invoiceId",
        Customer_Name: "deliveryDetails.fullName",
        Customer_Email: "deliveryDetails.email",
        Customer_Mobile: "deliveryDetails.phoneNumber",
        Product_Name: "productDetails.name",
        Brand_Name: "brandDetails.name",
        Delivery_Address: "deliveryDetails.address",
        Delivery_Landmark: "deliveryDetails.landMark",
        Delivery_City: "deliveryDetails.townCity",
        Delivery_State: "deliveryDetails.state",
        Date: {
          field: "createdAt",
          callback: (date) => {
            return new Date(date).toDateString();
          },
        },
      };
    },
  },
  mounted() {
    this.loadData();
    // console.log(this.productOrder.totalCount, "*********");
  },
};
</script>
